import { IInfoCardProps } from "./ICard";
import { useTranslation } from "react-i18next";
import DOMPurify from "isomorphic-dompurify";
import React from "react";
import Image from "next/image";

const InfoCard: React.FC<IInfoCardProps> = ({
  title,
  description,
  imageUrl,
  infoItems,
  language,
  bgColor,
}: IInfoCardProps) => {
  const { i18n } = useTranslation();
  const lang = language || i18n.language;
  const sanitizedTitle = DOMPurify.sanitize(title);

  return (
    <div
      className={`flex flex-col gap-4 items-center rounded-2xl ${bgColor} min-w-[17rem] max-w-[18rem] py-7 px-6 h-auto`}
    >
    
      <div style={{ minWidth: "27px", maxWidth: "35px", height: "35px" }}>
        <Image
            alt=""
            aria-hidden="true"
            src={imageUrl}
            width={35}  
            height={35}  
            className="w-full h-full"
            unoptimized
        />
      </div>

   
      <h3
        className="font-bold text-center mb-4"
        role="heading"
        aria-level={2}
        tabIndex={-1}
        dangerouslySetInnerHTML={{ __html: sanitizedTitle }}
      />

     
      <div className="flex flex-col gap-2 justify-between items-center h-full">
        {infoItems?.map((infoItem) => {
          const itemId = infoItem.id;
          const subtitle = DOMPurify.sanitize(infoItem.lblSubtitleInfo[lang]);
          const target = infoItem.flgTargetCtaInfo ? "_blank" : "_self";
          const href = infoItem.blLinkCtaInfo[lang];

          return (
            <React.Fragment key={itemId}>
              {href ? (
                <a
                  href={href}
                  target={target}
                  className="cursor-pointer"
                  role="link"
                >
                  <h3
                    className="hover:underline hover:text-[lightblue] text-center text-sm"
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                  />
                </a>
              ) : (
                <p
                  className="text-center text-sm"
                  dangerouslySetInnerHTML={{ __html: subtitle }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default InfoCard;
